// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"452":"46de3604","864":"39ac63a3"}[chunkId] + ".chunk.js";
};